import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { theme } from '@prose-ui';

import { MetaData } from 'Components/MetaData';

import { productsCategories, productsSubCategories } from 'constants/products';

import { Faq } from 'Blocks/Faq';
import Sustainability from 'Blocks/Sustainability';
import { Ticker } from 'Blocks/Ticker';
import Values from 'Blocks/Values';
import ProductVariantHero from '../Blocks/ProductVariantHero';
import ProductWithVariantsHero from '../Blocks/ProductWithVariantsHero';

import ScrollTracker from 'Containers/ScrollTracker';

import { srcOrNextImageProp } from 'PropTypes/imageProps';
import productProps from 'PropTypes/productProps';

import { LegacyBaseScene } from 'Scenes/LegacyBaseScene';

import { candlePageContent } from 'assets/content/productPages/candle';

import { getCandleProductPageContent } from 'dux/products/selectors';
import { useTrackProductViewed } from 'dux/products/hooks';

const CandleProductDetails = ({ content }) => {
  const { fragrancesHero, heroModule, sustainability, ticker } = content;

  useTrackProductViewed({
    category: productsCategories.OTHERS,
    subcategory: productsSubCategories.TOOLS,
    product: heroModule.product,
  });

  return (
    <>
      <MetaData
        description="Sustainably crafted, our scented candles are made with natural, paraffin-free wax and IFRA-compliant fragrance oils. Choose one of our three fragrances."
        title="Scented Candles – Accessories | Prose"
      />

      <LegacyBaseScene footer FooterProps={{ hideCTA: true }} header justifyContent="start">
        <ScrollTracker>
          <ProductWithVariantsHero content={heroModule} />
          <Ticker color={theme.colors.primary[400]} content={ticker} hasBorder showDash={false} />
          {fragrancesHero.map(fragrance => (
            <ProductVariantHero key={fragrance.slug} content={fragrance} />
          ))}
          <Values content={candlePageContent.values} />
          <Sustainability backgroundColor={theme.colors.neutral[100]} content={sustainability} />
          <Faq
            backgroundColor="vert"
            markupName="h3"
            questions={candlePageContent.faq}
            shouldGenerateJsonld
            title="Frequently asked questions"
            variant="dark"
          />
        </ScrollTracker>
      </LegacyBaseScene>
    </>
  );
};

CandleProductDetails.propTypes = {
  content: PropTypes.shape({
    fragrancesHero: PropTypes.arrayOf(
      PropTypes.shape({
        slug: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        subtitle: PropTypes.string.isRequired,
        images: PropTypes.shape({
          mobile: srcOrNextImageProp,
          desktop: srcOrNextImageProp,
          alt: PropTypes.string.isRequired,
        }),
      })
    ).isRequired,
    ticker: PropTypes.arrayOf(PropTypes.string).isRequired,
    heroModule: PropTypes.shape({
      imageCarousel: PropTypes.arrayOf(
        PropTypes.shape({
          image: srcOrNextImageProp,
          alt: PropTypes.string,
        })
      ),
      product: productProps.isRequired,
    }),
    sustainability: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      imageDesktop: srcOrNextImageProp,
      imageMobile: srcOrNextImageProp,
      imageAlt: PropTypes.string,
      logos: PropTypes.shape({
        bCorp: srcOrNextImageProp,
        climate: srcOrNextImageProp,
      }),
    }),
  }).isRequired,
};

export default connect(state => ({
  content: getCandleProductPageContent(state),
}))(CandleProductDetails);
